import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXHeadingComponent } from './heading.component';

const Module = [
    UBXHeadingComponent
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule
    ],
    exports: [
        Module
    ],
})
export class UBXHeadingModule {}
